const frame = (inner) =>
  `<svg class="art" viewBox="0 0 320 320" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">${inner}</svg>`;

const social = frame(`
  <g stroke="currentColor" stroke-width="2" opacity=".55">
    <path data-draw d="M160 159 74 98"/>
    <path data-draw d="M160 159 247 101"/>
    <path data-draw d="M160 159 245 240"/>
    <path data-draw d="M160 159 72 238"/>
    <path data-draw d="M74 98 72 238"/>
    <path data-draw d="M247 101 245 240"/>
  </g>
  <g class="fill-deep">
    <circle cx="74" cy="98" r="18"/>
    <circle cx="247" cy="101" r="14"/>
    <circle cx="245" cy="240" r="20"/>
    <circle cx="72" cy="238" r="13"/>
  </g>
  <g stroke="currentColor" stroke-width="3">
    <circle data-draw cx="74" cy="98" r="18"/>
    <circle data-draw cx="247" cy="101" r="14"/>
    <circle data-draw cx="245" cy="240" r="20"/>
    <circle data-draw cx="72" cy="238" r="13"/>
  </g>
  <g data-pop>
    <path class="fill-hot" d="M116 116h88a16 16 0 0 1 16 16v46a16 16 0 0 1-16 16h-30l-18 20-6-20h-34a16 16 0 0 1-16-16v-46a16 16 0 0 1 16-16z"/>
    <circle class="fill-deep" cx="140" cy="155" r="6"/>
    <circle class="fill-deep" cx="160" cy="155" r="6"/>
    <circle class="fill-deep" cx="180" cy="155" r="6"/>
  </g>`);

const photo = frame(`
  <g stroke="currentColor" stroke-width="3">
    <rect data-draw x="46" y="110" width="228" height="146" rx="22"/>
    <path data-draw d="M114 110l13-26h66l13 26"/>
    <rect data-draw x="70" y="132" width="30" height="16" rx="6"/>
    <circle data-draw cx="160" cy="184" r="54"/>
  </g>
  <circle data-draw class="hot" cx="160" cy="184" r="34" stroke-width="3"/>
  <g data-pop><circle class="fill-hot" cx="160" cy="184" r="17"/></g>
  <g data-pop><circle class="fill-cur" cx="146" cy="169" r="6"/></g>
  <g data-pop><circle class="fill-hot" cx="238" cy="140" r="9"/></g>`);

const video = frame(`
  <g stroke="currentColor" stroke-width="3">
    <path data-draw d="M54 118 258 80l10 42L64 160Z"/>
    <rect data-draw x="60" y="160" width="204" height="106" rx="16"/>
  </g>
  <g class="hot" stroke-width="3">
    <path data-draw d="M104 110 90 151"/>
    <path data-draw d="M148 102 134 143"/>
    <path data-draw d="M192 94 178 135"/>
    <path data-draw d="M236 86 222 127"/>
  </g>
  <g data-pop><path class="fill-hot" d="M146 189l50 24-50 24z"/></g>
  <g stroke="currentColor" stroke-width="2" opacity=".5">
    <path data-draw d="M84 246h156"/>
  </g>
  <g data-pop><circle class="fill-cur" cx="120" cy="246" r="6"/></g>`);

const web = frame(`
  <g stroke="currentColor" stroke-width="3">
    <rect data-draw x="44" y="72" width="232" height="176" rx="18"/>
    <path data-draw d="M44 114h232"/>
  </g>
  <g data-pop><circle class="fill-hot" cx="70" cy="93" r="6"/></g>
  <g stroke="currentColor" stroke-width="2.5">
    <circle data-draw cx="90" cy="93" r="6"/>
    <circle data-draw cx="110" cy="93" r="6"/>
  </g>
  <g data-pop><rect class="fill-hot" x="68" y="138" width="86" height="11" rx="5.5"/></g>
  <g data-pop>
    <rect class="soft" x="68" y="162" width="120" height="9" rx="4.5"/>
    <rect class="soft" x="68" y="181" width="96" height="9" rx="4.5"/>
  </g>
  <rect data-draw class="hot" x="68" y="204" width="74" height="26" rx="13" stroke-width="2.5"/>
  <g data-pop><rect class="soft" x="200" y="138" width="52" height="92" rx="12"/></g>
  <g data-pop><path class="fill-hot" d="M200 190v64l18-14 12 26 10-4-12-26h20z"/></g>`);

const app = frame(`
  <g stroke="currentColor" stroke-width="3">
    <rect data-draw x="104" y="44" width="112" height="232" rx="22"/>
    <path data-draw d="M146 64h28"/>
  </g>
  <g data-pop><rect class="fill-hot" x="124" y="92" width="30" height="30" rx="8"/></g>
  <g stroke="currentColor" stroke-width="2.5">
    <rect data-draw x="166" y="92" width="30" height="30" rx="8"/>
    <rect data-draw x="124" y="134" width="30" height="30" rx="8"/>
    <rect data-draw x="166" y="176" width="30" height="30" rx="8"/>
  </g>
  <g data-pop>
    <rect class="soft" x="166" y="134" width="30" height="30" rx="8"/>
    <rect class="soft" x="124" y="176" width="30" height="30" rx="8"/>
  </g>
  <rect data-draw class="hot" x="124" y="222" width="72" height="22" rx="11" stroke-width="2.5"/>
  <g stroke="currentColor" stroke-width="2" opacity=".5">
    <path data-draw d="M144 262h32"/>
  </g>
  <g data-pop><circle class="fill-hot" cx="216" cy="46" r="14"/></g>
  <g data-pop><circle class="fill-cur" cx="181" cy="191" r="6"/></g>`);

const ia = frame(`
  <g stroke="currentColor" stroke-width="2" opacity=".5">
    <circle data-draw cx="160" cy="150" r="104"/>
  </g>
  <path data-draw class="hot" d="M160 80c8 44 26 62 70 70-44 8-62 26-70 70-8-44-26-62-70-70 44-8 62-26 70-70z" stroke-width="3"/>
  <g stroke="currentColor" stroke-width="2.5">
    <path data-draw d="M86 74c2 10 6 14 16 16-10 2-14 6-16 16-2-10-6-14-16-16 10-2 14-6 16-16z"/>
  </g>
  <g data-pop><path class="soft" d="M160 80c8 44 26 62 70 70-44 8-62 26-70 70-8-44-26-62-70-70 44-8 62-26 70-70z"/></g>
  <g data-pop><path class="fill-hot" d="M238 218c3 14 8 19 22 22-14 3-19 8-22 22-3-14-8-19-22-22 14-3 19-8 22-22z"/></g>
  <g data-pop><circle class="fill-cur" cx="160" cy="150" r="8"/></g>`);

const pub = frame(`
  <g stroke="currentColor" stroke-width="3">
    <path data-draw d="M88 140 200 96v128L88 180Z"/>
    <path data-draw d="M88 140H62a12 12 0 0 0-12 12v16a12 12 0 0 0 12 12h26"/>
    <rect data-draw x="110" y="186" width="28" height="50" rx="14"/>
  </g>
  <g class="hot" stroke-width="3">
    <path data-draw d="M222 138a44 44 0 0 1 0 44"/>
    <path data-draw d="M246 118a78 78 0 0 1 0 84"/>
    <path data-draw d="M270 98a112 112 0 0 1 0 124"/>
  </g>
  <g data-pop><circle class="fill-hot" cx="160" cy="160" r="11"/></g>`);

const graph = frame(`
  <path data-draw class="hot" d="M66 210C66 122 138 92 172 148s70 62 82-10" stroke-width="3"/>
  <g stroke="currentColor" stroke-width="2" opacity=".55">
    <path data-draw d="M66 210V150"/>
    <path data-draw d="M172 148h58"/>
  </g>
  <g stroke="currentColor" stroke-width="2.5">
    <circle data-draw cx="66" cy="146" r="7"/>
    <circle data-draw cx="234" cy="148" r="7"/>
  </g>
  <g data-pop>
    <rect class="fill-cur" x="58" y="202" width="16" height="16" rx="2"/>
    <rect class="fill-cur" x="164" y="140" width="16" height="16" rx="2"/>
    <rect class="fill-cur" x="246" y="130" width="16" height="16" rx="2"/>
  </g>
  <g data-pop><circle class="fill-hot" cx="108" cy="264" r="19"/></g>
  <g stroke="currentColor" stroke-width="2.5">
    <circle data-draw cx="160" cy="264" r="19"/>
    <circle data-draw cx="212" cy="264" r="19"/>
  </g>
  <g data-pop><circle class="soft" cx="212" cy="264" r="19"/></g>`);

const event = frame(`
  <g stroke="currentColor" stroke-width="2" opacity=".5">
    <ellipse data-draw cx="160" cy="252" rx="116" ry="20"/>
  </g>
  <g class="hot" stroke-width="3">
    <path data-draw d="M62 56 112 234"/>
    <path data-draw d="M258 56 208 234"/>
  </g>
  <g stroke="currentColor" stroke-width="3">
    <rect data-draw x="138" y="84" width="44" height="78" rx="22"/>
    <path data-draw d="M122 140a38 38 0 0 0 76 0"/>
    <path data-draw d="M160 178v52"/>
    <path data-draw d="M136 232h48"/>
  </g>
  <g data-pop><rect class="soft" x="138" y="84" width="44" height="78" rx="22"/></g>
  <g data-pop>
    <circle class="fill-hot" cx="62" cy="56" r="12"/>
    <circle class="fill-hot" cx="258" cy="56" r="12"/>
  </g>
  <g data-pop>
    <rect class="fill-cur" x="224" y="128" width="12" height="12" rx="2" transform="rotate(20 230 134)"/>
    <rect class="fill-cur" x="80" y="168" width="12" height="12" rx="2" transform="rotate(-15 86 174)"/>
  </g>
  <g data-pop><circle class="fill-hot" cx="246" cy="190" r="6"/></g>
  <g data-pop><circle class="fill-hot" cx="74" cy="118" r="6"/></g>`);

export const ILLUS = { social, photo, video, web, app, ia, pub, graph, event };
